module.exports = __webpack_public_path__ + "img/bm-yandex.268c5bd9.png";